<template>
  <div class="info-box">
    {{ text }}
  </div>
</template>

<script setup lang="ts">
  interface Props {
    text: string
  }

  const props = defineProps<Props>()
</script>

<style scoped>
  .info-box {
    box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.15);
    padding: 1rem 2rem 1rem 1.5rem;
    border-left: 4px solid #fed600;
    background: #ffffff;
    margin: 1.5rem auto;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
